// extracted by mini-css-extract-plugin
export var form = "_df-0";